import { render, staticRenderFns } from "./AddPayday.vue?vue&type=template&id=4c1a1b26"
import script from "./AddPayday.vue?vue&type=script&lang=js"
export * from "./AddPayday.vue?vue&type=script&lang=js"
import style0 from "./AddPayday.vue?vue&type=style&index=0&id=4c1a1b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports